// extracted by mini-css-extract-plugin
export default {"listWrapper":"listWrapper_wS7ld","list":"list_MaJO9","listItem":"listItem_U4ldK","messageText":"messageText_W3zLv"};